import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase/firebase';

/**
 * Récupère la dernière prévisualisation générée d'un client (via deployment-service).
 * @param {string} uid - Identifiant du compte (users/{uid})
 * @returns {Promise<{previewUrl: string|null, previewedAt: string|null}>}
 */
export const getUserPreviewInfo = async (uid) => {
  try {
    const fn = httpsCallable(functions, 'getUserPreviewInfo');
    const res = await fn({ uid });
    return (res && res.data) || { previewUrl: null, previewedAt: null };
  } catch (error) {
    console.warn('previewService: impossible de récupérer la prévisualisation', error?.message);
    return { previewUrl: null, previewedAt: null };
  }
};
